import { TConfig } from '@@/interfaces';

import { AUTO_DISCOUNTS } from '../../autoDiscounts';

const ToggleOHConfig: DeepPartial<TConfig> = {
  autoDiscounts: [
    AUTO_DISCOUNTS.distantStudent,
    AUTO_DISCOUNTS.goodStudent,
    AUTO_DISCOUNTS.homeowner,
    AUTO_DISCOUNTS.multiPolicy,
    AUTO_DISCOUNTS.matureDriver60,
    AUTO_DISCOUNTS.multiCar,
    AUTO_DISCOUNTS.safeDriving,
    AUTO_DISCOUNTS.teenDriver,
  ],
  visibleCoverages: {
    protectionCoverages: [
      {
        label: 'Pet Passenger',
        key: 'pet_passenger',
      },
    ],
    vehicleCoverages: [
      {
        label: 'Uninsured Motorist Property Damage',
        key: 'uninsured_motorist_property_damage_limit',
      },
    ],
  },
  initialCoverageValues: {
    gap: 'false',
    temporary_ride: 'null',
    side_hustle: 'false',
    uninsured_motorist_property_damage_limit: '0',
  },
};
export default ToggleOHConfig;
